export function estAdmin(role) {
    return role === "admin";
}